import { updateVersion } from '@wix/ambassador-devcenter-versions-v1-versions-response/http';
import { VersionStatus } from '@wix/ambassador-devcenter-versions-v1-versions-response/types';
import { HttpClient } from '@wix/http-client';
const httpClient = new HttpClient();
export const publishVersion = async ({ appId, latestVersion, userId, }) => {
    await httpClient
        .request(updateVersion({
        appId,
        version: latestVersion,
        status: VersionStatus.PUBLISHED,
        triggeredBy: userId,
    }))
        .catch((err) => console.log(err));
};
//# sourceMappingURL=publishAppAction.js.map